// src/store.js
import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import { noteReducer } from './reducers/noteReducer';
import { authReducer } from './reducers/authReducer';
import { tagReducer } from './reducers/tagReducer';
import { socketMiddleware } from './reducers/socketMiddleware';

const rootReducer = combineReducers({
    noteState: noteReducer,
    authState: authReducer,
    tagState: tagReducer
});

export const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(socketMiddleware)

});